import { InstallAgentAdditionalTargetsFormWebComponent } from './component/InstallAgentAdditionalTargetsFormWebComponent';
import { WEB_COMPONENT_INSTALL_AGENT_ADDITIONAL_TARGETS } from '../../../../webcomponents.constants';

export { InstallAgentAdditionalTargetsFormWebComponent };

window.customElements.define(
  WEB_COMPONENT_INSTALL_AGENT_ADDITIONAL_TARGETS,
  InstallAgentAdditionalTargetsFormWebComponent
);
